import loadable from '@loadable/component';

const AssetLibrary = loadable(async () => import('./components/library'));
const ContentNav = loadable(async () => import('../common/components/nav/content-nav'));

export default {
  '/assets': {
    components: { main: AssetLibrary, nav: ContentNav }
  }
};
